import {
    InvoiceDeliveryNotification,
    InvoiceDeliveryWithDealerData,
    getInvoiceDeliveryDateEndpoint,
} from '@cp-mx/common';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from '../../cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

export const closeInvoiceDeliveryNotification = (contractNumber: string) =>
    sessionStorage.setItem(
        `InvoiceDeliveryNotification${contractNumber}`,
        `InvoiceDeliveryNotification${contractNumber}`,
    );

export const wasInvoiceDeliveryNotificationClosed = (contractNumber: string): boolean =>
    sessionStorage.getItem(`InvoiceDeliveryNotification${contractNumber}`) !== null;

export const removeInvoiceDeliveryNotificationsForSession = () => sessionStorage.clear();

const { reducer, fetchData, updateData } = getSimpleDataFetchSlice<
    InvoiceDeliveryNotification[],
    DefaultBusinessMarketApiErrorCode
>({
    dataName: 'invoiceDeliveryNotifications',
    fetchCallback() {
        return CpDataApi.get<InvoiceDeliveryWithDealerData[]>(getInvoiceDeliveryDateEndpoint()).then(response =>
            response.data.map(invoiceDelivery => ({
                ...invoiceDelivery,
                notificationClosed: wasInvoiceDeliveryNotificationClosed(invoiceDelivery.contractNumber),
            })),
        );
    },
});

export default reducer;
export const fetchInvoiceDeliveries = fetchData;
export const updateInvoiceDeliveryNotifications = updateData;
